import { Box } from "@chakra-ui/react";
import { baseColors } from "goi_common/src/design-system";

import { HEADER_HEIGHT } from "@/constants/components";
import type { GuestCostRange } from "../utils/parlorIntroCost";
import CostRangeCard from "./CostRangeCard";

/**
 * 질문 화면 위에 붙어 따라오는 예상 비용 카드. 선택지를 누르며 내려가도 금액이 바뀌는 게 보이게 한다.
 * top 은 기존 견적 게이지(#296)와 같은 값. 모바일 두 번째 헤더 줄은 스크롤하면 사라져 HEADER_HEIGHT 만 둔다.
 */
export default function StickyCostCard({
  range,
  selected,
}: {
  range: GuestCostRange;
  selected: { lo: number; hi: number } | null;
}) {
  return (
    <Box position="sticky" top={`${HEADER_HEIGHT}px`} zIndex={5} bg={baseColors.background_normal}>
      <CostRangeCard range={range} selected={selected} />
    </Box>
  );
}
